import { AppleLogo, GooglePlayLogo } from '@phosphor-icons/react';
import ExternalLink from './ExternalLink';
import { externalLinks } from '../config/links';

/**
 * The two mobile download buttons. Links come from config/links.js and stay
 * inert until the listings are published.
 */
export default function StoreBadges({ className = '' }) {
  return (
    <div className={`store-badges ${className}`.trim()}>
      <ExternalLink
        className="store-badge"
        href={externalLinks.appStore}
        aria-label="Download ShareShutter on the App Store"
      >
        <AppleLogo className="store-badge__logo" size={26} weight="fill" aria-hidden="true" />
        <span className="store-badge__text">
          <span className="store-badge__kicker">Download on the</span>
          <span className="store-badge__name">App Store</span>
        </span>
      </ExternalLink>

      <ExternalLink
        className="store-badge"
        href={externalLinks.googlePlay}
        aria-label="Get ShareShutter on Google Play"
      >
        <GooglePlayLogo className="store-badge__logo" size={24} weight="fill" aria-hidden="true" />
        <span className="store-badge__text">
          <span className="store-badge__kicker">Get it on</span>
          <span className="store-badge__name">Google Play</span>
        </span>
      </ExternalLink>
    </div>
  );
}
